export const getOneTrustConsentGroups = (window: Window) => {
    const optanonConsent = window.document.cookie
        .split('; ')
        .find(row => row.startsWith('OptanonConsent'));

    if (!optanonConsent) {
        return;
    }
    const [, groups] =
        /groups=(.*?)(?:$|&)/i.exec(decodeURIComponent(optanonConsent)) || [];

    if (!groups) {
        return;
    }

    return groups.split(',').reduce<Record<string, string>>((acc, item) => {
        const [key, value] = item.split(':');
        acc[key] = value;

        return acc;
    }, {});
};
